(() => {
  if (window.__wdltMobileEmphasis) return;
  window.__wdltMobileEmphasis = true;
  const media = matchMedia('(max-width:749px)');
  const entries = new Map();
  const pointers = new Map();
  const duration = 800;
  function target(element) {
    if (!(element instanceof Element)) return null;
    const control = element.closest('a[href],button,summary,[role="button"],label[for],label.wdlt-filter-choice');
    if (!control || control.matches(':disabled,[aria-disabled="true"]')) return null;
    if (control.classList.contains('wdlt-hp__cover')) return control.parentElement.querySelector('.wdlt-hp__overlay');
    return control.textContent.trim() ? control : null;
  }
  function state(node) {
    if (!entries.has(node)) entries.set(node, {hover:false, pressed:false, focused:false, timer:null});
    return entries.get(node);
  }
  function update(node, reason, enabled) {
    if (!node || !media.matches) return;
    const entry = state(node);
    clearTimeout(entry.timer);
    entry[reason] = enabled;
    if (entry.hover || entry.pressed || entry.focused) {
      node.classList.add('wdlt-mobile-emphasis');
      return;
    }
    entry.timer = setTimeout(() => {
      node.classList.remove('wdlt-mobile-emphasis');
      entries.delete(node);
    }, duration);
  }
  function clear() {
    entries.forEach((entry,node) => {clearTimeout(entry.timer);node.classList.remove('wdlt-mobile-emphasis');});
    entries.clear();
    pointers.clear();
  }
  document.addEventListener('pointerover', event => {
    if (event.pointerType === 'touch') return;
    const node = target(event.target);
    if (node !== target(event.relatedTarget)) update(node, 'hover', true);
  }, {passive:true});
  document.addEventListener('pointerout', event => {
    if (event.pointerType === 'touch') return;
    const node = target(event.target);
    if (node !== target(event.relatedTarget)) update(node, 'hover', false);
  }, {passive:true});
  document.addEventListener('pointerdown', event => {
    if (!media.matches) return;
    const node = target(event.target);
    if (node) {pointers.set(event.pointerId,node);update(node, 'pressed', true);}
  }, {passive:true});
  document.addEventListener('pointerup', event => {
    const node = pointers.get(event.pointerId);
    pointers.delete(event.pointerId);
    update(node, 'pressed', false);
  }, {passive:true});
  document.addEventListener('pointercancel', event => {
    const node = pointers.get(event.pointerId);
    pointers.delete(event.pointerId);
    if (!node) return;
    const entry = entries.get(node);
    if (entry) clearTimeout(entry.timer);
    entries.delete(node);
    node.classList.remove('wdlt-mobile-emphasis');
  }, {passive:true});
  document.addEventListener('focusin', event => {
    if (event.target instanceof Element && event.target.matches(':focus-visible')) update(target(event.target), 'focused', true);
  });
  document.addEventListener('focusout', event => update(target(event.target), 'focused', false));
  media.addEventListener('change', clear);
  window.addEventListener('pagehide', clear);
  window.addEventListener('pageshow', clear);
})();
